<template>
  <img
    :src="src"
    :style="customStyle"
    class="generic-image"
    alt=""
  >
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    component: {
      type: Object,
      required: true
    },
  },
  computed: {
    src() {
      return _.get(this.component, 'image_url', '')
    },
    customStyle() {
      return _.get(this.component, 'props.style', {})
    }
  },
}
</script>

<style lang="scss" scoped>
.generic-image {
  display: block;
  object-fit: cover;
  margin: 0 auto;
}
</style>
